import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Plane, TrendingDown } from 'lucide-react';
import { formatCurrency, getContinentByDestination } from '../lib/helpers';
import { getDestinationImage } from '../lib/images';
import { Badge } from './ui/badge';

export const DealCard = ({ promotion, index }) => {
  const continent = getContinentByDestination(promotion.destination);
  const imageUrl = getDestinationImage(promotion.destination);
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
      data-testid={`deal-card-${index}`}
    >
      <Link to={`/promotion/${promotion.id}`}>
        <div className="deal-card bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden group">
          <div className="relative h-48 overflow-hidden">
            <img 
              src={imageUrl}
              alt={promotion.destination}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4">
              <Badge variant="secondary" className="mb-2 bg-white/90 backdrop-blur-sm">
                {continent}
              </Badge>
            </div>
          </div>
          <div className="p-6">
            <div className="flex items-start justify-between mb-4">
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-slate-900 mb-1" data-testid="route-title">
                  {promotion.origin} &rarr; {promotion.destination}
                </h3>
                <p className="text-sm text-slate-600">{promotion.airline}</p>
              </div>
              <div className="w-12 h-12 bg-[#00A8B5]/10 rounded-full flex items-center justify-center group-hover:bg-[#00A8B5]/20 transition">
                <Plane className="w-6 h-6 text-[#00A8B5]" />
              </div>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <span className="text-xs px-2 py-1 bg-slate-100 rounded-full text-slate-700">
                {promotion.cabin}
              </span>
              <span className="text-xs px-2 py-1 bg-slate-100 rounded-full text-slate-700">
                {promotion.trip_type}
              </span>
            </div>

            <div className="border-t border-dashed border-slate-200 pt-4 mt-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3">
                <div className="w-full sm:w-auto">
                  <p className="text-xs text-slate-600 mb-1">Rota Continental</p>
                  <p className="text-2xl font-bold text-[#00A8B5]" data-testid="calculated-price">
                    {formatCurrency(promotion.calculated_price)}
                  </p>
                </div>
                
                {promotion.savings_percentage > 0 && (
                  <div className="w-full sm:w-auto sm:text-right">
                    <div className="flex items-center gap-1 text-green-600 mb-1">
                      <TrendingDown className="w-4 h-4" />
                      <span className="text-xs font-medium">Economia</span>
                    </div>
                    <div className="text-2xl font-bold text-green-600" data-testid="savings-percentage">
                      {promotion.savings_percentage}%
                    </div>
                  </div>
                )}
              </div>
              
              {promotion.skyscanner_price && (
                <div className="mt-3 pt-3 border-t border-slate-100">
                  <p className="text-xs text-slate-500">
                    Preço médio Skyscanner: <span className="line-through">{formatCurrency(promotion.skyscanner_price)}</span>
                  </p>
                </div>
              )}
            </div>

            <button 
              className="w-full mt-4 bg-[#00A8B5] hover:bg-[#008C99] text-white font-semibold py-3 px-6 rounded-full transition shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-sm sm:text-base"
              data-testid="view-dates-button"
            >
              Ver datas disponíveis
            </button>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
